export const getSearchUrl = (baseUrl: string, language: string, searchTerm: string) => {
    return `${baseUrl}/${language.toLowerCase()}/technical_pages/suche/suche.html?q=${encodeURIComponent(
        searchTerm
    )}`;
};
